import { RowDragEndEvent } from '@ag-grid-community/core';
import { useCallback, useContext, useEffect, useRef } from 'react';

import { useDroppedFileContext } from 'src/components/chat/inner-channel/custom-message-input/DroppedFileContext';
// eslint-disable-next-line no-restricted-imports
import { AgGridContext } from 'src/legacy/components/AgGrid';
import { FilesTableData } from 'src/store/files/types';

interface UseMessageInputDropZoneProps {
  isInternalChat: boolean;
}

export const useMessageInputDropZone = ({
  isInternalChat,
}: UseMessageInputDropZoneProps) => {
  const gridContext = useContext(AgGridContext);
  const gridApi = gridContext?.gridApi;
  const messageInputRef = useRef<HTMLDivElement>(null);
  const { addDroppedFile } = useDroppedFileContext();

  // Handle file drop from AgGrid
  const handleFileDrop = useCallback(
    (fileData: FilesTableData) => {
      // Add file to the dropped files context
      addDroppedFile(fileData);
    },
    [addDroppedFile],
  );

  // Set up drop zone on message input when in internal chat
  useEffect(() => {
    if (!isInternalChat || !gridApi || !messageInputRef.current) {
      return;
    }

    const dropZoneParams = {
      getContainer() {
        return messageInputRef.current!;
      },
      onDragStop(params: RowDragEndEvent) {
        const fileData = params.node.data as FilesTableData;
        handleFileDrop(fileData);
      },
      onDragEnter() {
        // File drag entered message input
      },
      onDragLeave() {
        // File drag left message input
      },
    };

    gridApi.removeRowDropZone(dropZoneParams);
    gridApi.addRowDropZone(dropZoneParams);

    return () => {
      // Clean up drop zone when component unmounts or dependencies change
      gridApi.removeRowDropZone(dropZoneParams);
    };
  }, [isInternalChat, gridApi, handleFileDrop]);

  return {
    messageInputRef,
  };
};
